module.exports = __webpack_public_path__ + "img/car4you.978e3d61.svg";